<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Pays</h6>
                <a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalCountry" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess"><i class="fas fa-plus fa-md"></i></a>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableCountry" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th>Nom Anglais</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th>Nom Anglais</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in countries" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.name_en}}</td>
                        <td class="text-center">
                          <a class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalCountry" v-on:click="viewCountry(item.id)" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </a>
                          <a class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalCountry" v-on:click="viewCountry(item.id)" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </a>
                          <a class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalCountry" v-on:click="viewCountry(item.id)" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Country -->
    <div class="modal fade" id="addModalCountry" tabindex="-1" role="dialog" aria-labelledby="ModalCountryLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addCountryForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCountryLabel">Ajouter Pays</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code1" name="code1" required>
                </div>
                <div class="col-sm-6">
                  <label for="area_id1">Région</label>
                  <select class="form-control mb-2" v-model="area_id1" name="area_id1" required>
                    <option v-for="area in areas" :key="area.id" :value="area.id">
                      {{ area.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-6">
                  <label>Nom Anglais</label>
                  <input type="text" class="form-control mb-2" v-model="name_en1" name="name_en1" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addCountry" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addCountryProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Country -->
    <div class="modal fade" id="viewModalCountry" tabindex="-1" role="dialog" aria-labelledby="ModalCountryLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalCountryLabel">Pays [#<span>{{indexCountry+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Code</th>
                  <td>{{code2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom Anglais</th>
                  <td>{{name_en2}}</td>
                </tr>
                <tr>
                  <th scope="row">Région</th>
                  <td>{{getAreaName(area_id2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Country -->
    <div class="modal fade" id="editModalCountry" tabindex="-1" role="dialog" aria-labelledby="ModalCountryLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editCountryForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCountryLabel">Modifier Pays [#<span>{{indexCountry+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code3" name="code3" required>
                </div>
                <div class="col-sm-6">
                  <label for="area_id1">Région</label>
                  <select class="form-control mb-2" v-model="area_id3" name="area_id3" required>
                    <option v-for="area in areas" :key="area.id" :value="area.id">
                      {{ area.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
                <div class="col-sm-6">
                  <label>Nom Anglais</label>
                  <input type="text" class="form-control mb-2" v-model="name_en3" name="name_en3" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editCountry" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editCountryProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- delete Modal Country -->
    <div class="modal fade" id="deleteModalCountry" tabindex="-1" role="dialog" aria-labelledby="ModalCountryLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalCountryLabel">Supprimer Pays [#<span>{{indexCountry+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer ce pays ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteCountry" v-bind:disabled="addCountryProcess || editCountryProcess || deleteCountryProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteCountryProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      country: {},
      indexCountry: '',
      areas: [],
      countries: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addCountryProcess: false,
      viewCountryProcess: false,
      editCountryProcess: false,
      deleteCountryProcess: false,
      code1: '',
      name1: '',
      name_en1: '',
      area_id1: '',
      id2: '',
      code2: '',
      name2: '',
      name_en2: '',
      area_id2: '',
      code3: '',
      name3: '',
      name_en3: '',
      area_id3: '',
      dTableCountry: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableCountry = $('#dataTableCountry').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          deferRender: true,
          fixedColumns: true
        })
        this.country = {
          'id': '',
          'code': '',
          'name': '',
          'name_en': '',
          'area_id': ''
        }
        this.code1 = ''
        this.name1 = ''
        this.name_en1 = ''
        this.area_id1 = ''
        this.id2 = ''
        this.code2 = ''
        this.name2 = ''
        this.name_en2 = ''
        this.area_id2 = ''
        this.code3 = ''
        this.name3 = ''
        this.name_en3 = ''
        this.area_id3 = ''
      }, 50)
    },
    //Sélectionner tous les pays (Base de données)
    getCountries () {
      axios.get(this.apiUrl+'/countries', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.countries = res.data
          this.progress += 1
          if (this.progress === 2) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les Régions (Base de données)
    getAreas () {
      axios.get(this.apiUrl+'/areas', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.areas = res.data
          this.progress += 1
          if (this.progress === 2) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getAreaName(areaId) {
          const area = this.areas.find((a) => a.id === areaId);
          return area ? area.name : ''; // Devuelve el nombre o un valor predeterminado
    },
    //Ajouter un pays
    addCountry () {
      if ($('#addCountryForm').isValid()) {
        this.addCountryProcess = true
        let country = {
          id: this.countries.length + 1,
          code: this.code1,
          name: this.name1,
          name_en: this.name_en1,
          area_id: this.area_id1
        }
        axios.post(this.apiUrl+'/countries', country, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.countries.push(country)
            this.dTableCountry.destroy()
            this.init()
          }
          $('#addModalCountry').modal('hide')
          this.addCountryProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalCountry').modal('hide')
          this.addCountryProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner un pays (Local)
    viewCountry (id) {
      this.country = this.countries.filter(function (item) {
        return item.id === id
      })[0]
      this.indexCountry = this.countries.indexOf(this.country)
      this.id2 = this.country.id
      this.code2 = this.country.code
      this.name2 = this.country.name
      this.name_en2 = this.country.name_en
      this.area_id2 = this.country.area_id
      this.code3 = this.country.code
      this.name3 = this.country.name
      this.name_en3 = this.country.name_en
      this.area_id3 = this.country.area_id
    },
    //Modifier un pays
    editCountry () {
      if ($('#editCountryForm').isValid()) {
        var id = this.country.id
        this.editCountryProcess = true
        axios.put(this.apiUrl+'/countries/' + id, {
          code: this.code3,
          name: this.name3,
          name_en: this.name_en3,
          area_id: this.area_id3,
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.country.code = this.code3
            this.country.name = this.name3
            this.country.name_en = this.name_en3
            this.country.area_id = this.area_id3
            this.countries[this.indexCountry] = this.country
            this.dTableCountry.destroy()
            this.init()
          }
          $('#editModalCountry').modal('hide')
          this.editCountryProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalCountry').modal('hide')
          this.editCountryProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer un pays
    deleteCountry () {
      var id = this.country.id
      this.deleteCountryProcess = true
      axios.delete(this.apiUrl+'/countries/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.countries.splice(this.indexCountry, 1)
            this.dTableCountry.destroy()
            this.init()
          }
          $('#deleteModalCountry').modal('hide')
          this.deleteCountryProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          this.addCountryProcess = false
          $('#deleteModalCountry').modal('hide')
          setTimeout(function () {
            this.messageAlert2 = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getAreas()
    this.getCountries()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Country.vue